<template lang="html">
  <section class="contenedor-perfil" :style="styles.backgroundWhite">

    <template v-if="!!perfil">



      <h2 class="ficha-title -big" :style="styles.colorBasic">{{$t('mi_perfil')}}</h2>

      <div class="contenedor-datos-perfil row-start ais">

        <h4 class="epigrafe" :style="styles.colorBasic">{{$t('datos_personales_contacto')}}</h4>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('nombre')}}</h4>
          <p>{{(!!perfil.nombre) ? perfil.nombre : $t('sin_introducir')}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('apellidos')}}</h4>
          <p>{{(!!perfil.apellidos) ? perfil.apellidos : $t('sin_introducir')}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('dni')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.dni) ? perfil.dni : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" name="dni" :style="styles.input_black" v-model="perfil.dni"
              v-validate="'required|checkDNI'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('dni') }}</span>
          </div>

        </div>


        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('email')}}</h4>
          <p>{{(!!perfil.email) ? perfil.email : $t('sin_introducir')}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{$t('telefono_profesional')}}<span v-if="edit">*</span></h4>
          <p v-if="!edit">{{(!!perfil.telefonoProfesional) ? perfil.telefonoProfesional : $t('sin_introducir')}}</p>
          <div class="contenedor-input" v-if="edit">
            <input type="text" :style="styles.input_black" v-model="perfil.telefonoProfesional"
              name="telefonoProfesional" v-validate="'required|min:9'">
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('telefonoProfesional') }}</span>
          </div>
        </div>

        <div class="contenedor-botones">
          <a class="btn" v-if="!edit" :style="styles.solidPrimary" @click="edit= true">{{$t('editar_datos')}}</a>
          <a class="btn" v-if="edit" :style="styles.solidPrimary" @click="savedata" :loading="loading">{{$t('guardar_datos')}}</a>

          <p class="explain" v-html="$t('si_datos_erroneos')"></p>

        </div>
      </div>

    </template>

    <loading v-else></loading>


  </section>
</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import Datepicker from 'vuejs-datepicker';

  import { es } from 'vuejs-datepicker/dist/locale'

  import { Validator } from 'vee-validate';

  import loading from '@/components/parts/loading';
  import predictivo from '@/components/parts/predictivo';

  Validator.extend('checkDNI', {
    validate: dni => {

      let numero, letr, letra;
      let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

      dni = dni.toUpperCase();

      if (expresion_regular_dni.test(dni) === true) {
        numero = dni.substr(0, dni.length - 1);
        numero = numero.replace('X', 0);
        numero = numero.replace('Y', 1);
        numero = numero.replace('Z', 2);
        letr = dni.substr(dni.length - 1, 1);
        numero = numero % 23;
        letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
        letra = letra.substring(numero, numero + 1);
        return (letra == letr);
      } else {
        return false;
      }

    }
  });



  export default {
    name: 'mi-perfil',
    data() {
      return {
        perfil: '',
        edit: false,
        es: es,
        clicked: false,
        loading: false
      }
    },
    mounted() {
      this.getdata();
    },
    methods: {
      ...mapActions([
        'requestMiPerfil',
        'saveMiPerfil',
      ]),
      getdata() {
        setTimeout(e => {
          this.requestMiPerfil().then(r => {
            this.perfil = r;
          })
        }, 100)
      },
      savedata() {
        this.clicked = true;
        this.$validator.validateAll().then(itsOk => {
          if (itsOk) {
            this.loading = true;
            this.saveMiPerfil(this.perfil).then(r => {
              this.loading = false;
              this.edit = false;
            });
          }
        });

      },
      eraseObservacion(observacion) {
        this.perfil.observaciones = this.perfil.observaciones.filter(o => o.texto != observacion.texto);
      },
      addObservacion() {
        let fecha = new Date();
        let observacion = {
          texto: '',
          fecha: ''
        };
        observacion.fecha = `${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()}`;
        this.perfil.observaciones.push(observacion);
      }
    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        colors: 'basicColors',
        totales: 'getTotales',
        dominios: 'getDominios',
        dominiosOrder: 'getDominiosOrder',
      }),
    },
    components: {
      Datepicker,
      'loading': loading,
      'predictivo': predictivo
    },
    watch: {
      'edit'() {
        this.$validator.reset();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/mi-perfil.vue